let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("9gTl3")]).then(() => parcelRequire('ekO4Z'));